import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useCalendarStore = defineStore('calendar', {
  state,
  getters,
  actions
})

export default useCalendarStore
